<script setup>
defineProps({
  message: {
    type: String,
    default: ''
  }
})
</script>

<template>
  <p v-if="message" class="text-sm text-red-500 mt-2 flex items-center">
    <span class="material-symbols-outlined text-lg mr-1">error</span>
    {{ message }}
  </p>
</template>
